import { useQuery } from '@hooks/reactQuery';

import { getAssetRequestStatuses } from '@api/assetsRent';

import { optionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { ASSET_RENT_REQUESTS_TYPES } from '@constants/queryKeys';

interface IUseAssetRentRequestStatusesReturnType {
	requestsStatuses: Array<TSelectOption>;
	isLoadingRequestsStatuses: boolean;
	isFetchingRequestsStatuses: boolean;
}

export const useQueryAssetRentRequestStatuses = ():
	IUseAssetRentRequestStatusesReturnType => {
	const {
		data: requestsStatuses,
		isLoading: isLoadingRequestsStatuses,
		isFetching: isFetchingRequestsStatuses,
	} = useQuery({
		queryKey: [ASSET_RENT_REQUESTS_TYPES],
		queryFn: getAssetRequestStatuses,
		select: requestTypes => optionsFormatted(requestTypes),
		...refetchOptions,
	});

	return {
		requestsStatuses: optionsFormatted(requestsStatuses || []),
		isLoadingRequestsStatuses,
		isFetchingRequestsStatuses,
	};
};
